import { render } from "./base-file-uploader.vue?vue&type=template&id=07c22fb3&scoped=true&ts=true"
import script from "./base-file-uploader.vue?vue&type=script&lang=ts"
export * from "./base-file-uploader.vue?vue&type=script&lang=ts"

import "./base-file-uploader.vue?vue&type=style&index=0&id=07c22fb3&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c22fb3"]])

export default __exports__